import React, { RefObject } from "react";
import { Flex, Spinner, Box } from "@chakra-ui/react";
import Card from "../enrollment-card/card";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";
import { TrendingTitle } from "../kpecDashboard/style";
import ViewAllToggle from "../common/ViewAllToggle";
import useMediaQ from "@root/hooks/useMediaQ";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";

interface EnrollmentListPropsExtended extends EnrollmentListProps {
  courseCardRef?: RefObject<HTMLDivElement>;
}

const EnrollmentList: React.FC<EnrollmentListPropsExtended> = ({
  courses,
  showLimited = true,
  count = 3,
  loading = false,
  courseCardRef,
}) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { sm } = useMediaQ();
  const isMobile = !sm;
  const loggedInUser = useSelector(getLoggedInUser);
  const isLoggedIn = !!loggedInUser;

  // removed unused renderCourseCards

  const totalCount = courses?.length || 0;
  const [expanded, setExpanded] = React.useState(false);
  const showToggle = totalCount > count;
  const visibleCourses =
    expanded || !showLimited ? courses : courses?.slice(0, count);

  const handleToggle = () => {
    if (!expanded) {
      navigate(
        isLoggedIn
          ? ROUTE_NAMES.JOURNALIST_COURSES
          : ROUTE_NAMES.UNAUTHENTICATED_COURSES,
      );
    } else {
      setExpanded(false);
    }
  };

  const renderCourseCard = (course: any, index: number) => {
    const isFirstCard = index === 0;

    return (
      <Box ref={isFirstCard ? courseCardRef : undefined} key={index}>
        <Card
          course={course}
          onClick={() => {
            navigate(
              isLoggedIn
                ? `${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${course?.id}`
                : `${ROUTE_NAMES.UNAUTHENTICATED_COURSE_DETAIL}/${course?.id}`,
            );
          }}
        />
      </Box>
    );
  };

  const renderEnrollmentList = () => {
    if (loading) {
      return (
        <Flex justify="center" align="center" minHeight="200px">
          <Spinner size="lg" />
        </Flex>
      );
    }

    if (isMobile) {
      return (
        <div
          style={{
            width: "100%",
            maxHeight: "330px",
            overflowY: "scroll",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            paddingRight: "4px",
          }}
        >
          {visibleCourses?.map((course, index) =>
            renderCourseCard(course, index),
          )}
        </div>
      );
    }

    // Desktop layout (original)
    return (
      <Flex
        as="div"
        sx={{
          display: "grid",
          gridTemplateColumns: {
            base: "1fr",
            sm: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(2, 1fr)",
            xl: "repeat(3, 1fr)",
            "2xl": "repeat(4, 1fr)",
          },
          gap: "15px",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        {visibleCourses?.map((course, index) =>
          renderCourseCard(course, index),
        )}
      </Flex>
    );
  };

  return (
    <>
      <Flex
        align="center"
        justify="space-between"
        width="100%"
      >
        <TrendingTitle alignSelf={"flex-start"} mb={'12px'}>
          {t("kpecDashboard.recommendedCourses")}
        </TrendingTitle>
        <ViewAllToggle
          expanded={expanded}
          onToggle={handleToggle}
          showToggle={showToggle}
        />
      </Flex>
      {renderEnrollmentList()}
    </>
  );
};

export default EnrollmentList;
